import WebDevImage from "../assets/images/business/website-unique-design.webp";
import MobileDevImage from "../assets/images/devices/responsive-web-devices.webp";
import SeoImage from "../assets/images/devices/seo-analysis-screen.webp";
import HostingImage from "../assets/images/devices/hosting-services-devices.webp";

export const serviceCategories = [
  { key: "webDevelopment", slug: "web-development", image: WebDevImage },
  { key: "mobileApp", slug: "mobile-app", image: MobileDevImage },
  { key: "seoMarketing", slug: "seo-marketing", image: SeoImage },
  { key: "hosting", slug: "hosting", image: HostingImage },
];

export function getServiceCategoryBySlug(slug) {
  if (!slug) return null;
  return serviceCategories.find((c) => c.slug === slug) ?? null;
}
